import { createdAtToTimestamp } from './createdAtToTimestamp'
import { getChatSession } from './getChatSession'
import { renderChat } from './renderChat'
import { saveChatSession } from './saveChatSession'
import { saveChatUserToSession } from './saveChatUserToSession'

/**
 * Sends a chat message
 * @param {import('@livechat/customer-sdk').CustomerSDK} instance
 * @param {string} text
 */
export async function sendMessage(instance, text) {
  const timestamp = Date.now()
  const customId = `customer-${timestamp}`

  console.info('send message', customId, text)

  const session = getChatSession()

  if (!session.chatId) {
    console.info('starting chat:', session)

    // @ts-ignore livechat SDK has a bug with types here, need to report
    const { chat: incomingChat } = await instance.startChat({
      continuous: true,
    })
    session.chatId = incomingChat.id
    session.chatActive = true
    console.info('chat to start:', incomingChat)
  } else {
    const chats = await instance.listChats()
    const chat = chats.chatsSummary.find((c) => c.id === session.chatId)

    if (!chat) {
      console.info('starting chat:', session)
      // @ts-ignore livechat has a bug with types here, need to report
      const { chat: incomingChat } = await instance.startChat({
        continuous: true,
      })
      session.chatId = incomingChat.id
      session.chatActive = true
      console.info('chat to start:', session)
    } else if (!chat.active) {
      console.info('resuming chat:', session)
      await instance.resumeChat({
        chat: {
          id: session.chatId,
        },
        continuous: true,
      })
      session.chatActive = true
      console.info('chat to resume:', session)
    }
  }

  const event = await instance.sendEvent({
    chatId: session.chatId,
    event: {
      customId,
      properties: {},
      text,
      timestamp,
      type: 'message',
    },
  })

  session.conversation.push({
    authorId: event.authorId,
    authorType: 'user',
    id: event.id,
    text,
    timestamp: createdAtToTimestamp(event.createdAt),
  })

  saveChatSession(session)

  console.info('message sent', event)

  const messageInput = /** @type {HTMLTextAreaElement | null} */ (
    document.getElementById('message-input')
  )
  if (!messageInput) {
    throw new Error('unexpected: message input not found')
  }

  messageInput.value = ''

  renderChat()

  const r = await instance.listChats()
  const chat = r.chatsSummary.find((c) => c.id === session.chatId)
  if (chat) {
    chat.users.forEach((u) => saveChatUserToSession(u))
  }
}
